/*******************************************************************************
* Project: J-SIPHE
* Summary:
*    Define CurrrencyFormatPipe Pipe
* History:
*    NguyenTV            2021/07/02    Create currrency format pipe
******************************************************************************/

import { Pipe, PipeTransform } from '@angular/core';
import { CurrencyPipe } from '@angular/common';
import { CurrencyCodeConst } from '../shared/constant';
@Pipe({ name: 'currencyFormatPipe' })
export class CurrrencyFormatPipe implements PipeTransform {

    constructor(private currencyPipe: CurrencyPipe) { }

    transform(pPrice: string, pStrCountryCode: string, pBlnIsShowSymbol = false): string {
        try {
            if (pPrice !== undefined && pPrice != null && pPrice !== '' && !isNaN(Number(pPrice))) {
                const currency = CurrencyCodeConst.find(x => x.CountryCode === pStrCountryCode);
                const strCurrencyCode = currency !== undefined && currency != null ? currency.CurrencyCode : '';
                const strSymbol = pBlnIsShowSymbol === false ? '' : 'symbol';
                return this.currencyPipe.transform(Number(pPrice), strCurrencyCode, strSymbol);
            } else {
                return '';
            }
        } catch (err) {
            return '';
        }
    }
}


